import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export default function Header() {
    const { user, isPro, signOut } = useAuth();
    const navigate = useNavigate();

    return (
        <header className="bg-white shadow-sm safe-top">
            <div className="max-w-lg mx-auto px-4 py-3 flex items-center justify-between">
                {/* Logo */}
                <div className="flex items-center gap-2">
                    <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center">
                        <span className="text-white text-lg">♻️</span>
                    </div>
                    <span className="font-bold text-xl text-gray-900">BinIt</span>
                    {isPro && (
                        <span className="bg-primary-500 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                            PRO
                        </span>
                    )}
                </div>

                {/* User Actions */}
                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <button
                                onClick={() => navigate('/settings')}
                                className="text-gray-500 hover:text-gray-700"
                                title="Settings"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                            </button>
                            <button
                                onClick={() => signOut()}
                                className="text-sm text-gray-600 hover:text-gray-900"
                            >
                                Sign Out
                            </button>
                        </>
                    ) : (
                        <button
                            onClick={() => navigate('/auth')}
                            className="text-sm text-primary-600 font-semibold hover:text-primary-700"
                        >
                            Sign In
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
}
